import { Component } from "@angular/core";

@Component({
    selector: 'mdk-mo-card-flow',
    templateUrl: './mo-card-flow.component.svg'
})
export class MoCardFlowComponent {}